import { ACTION_TYPES } from 'Constants'

const initialState = {
  triggerHeader: false,
  profiledetails: localStorage.getItem("profiledetails") || "",
}

const ProfileSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.PROFILE_SETTINGS: {
      return {
        ...state,
        triggerHeader: action.payload,
      }
    }
    case ACTION_TYPES.PROFILE_DETAILS: {
      localStorage.setItem("profiledetails", action.payload);
      return {
        ...state,
        profiledetails:action.payload,
      }
    }
    default:
      return state
  }
}

export default ProfileSettingsReducer
